import React, { createContext, useContext, useState, useCallback } from "react";
import api from "./lib/api";

const DICT = {
  app_name: { en: "Aptocore Field Force", hi: "एप्टोकोर फील्ड फोर्स" },
  company: { en: "Aptocore Biosciences", hi: "एप्टोकोर बायोसाइंसेज" },
  login: { en: "Login", hi: "लॉगिन" },
  logout: { en: "Logout", hi: "लॉगआउट" },
  employee_id: { en: "Employee ID / Mobile", hi: "कर्मचारी आईडी / मोबाइल" },
  pin: { en: "4-Digit PIN", hi: "4-अंकीय पिन" },
  remember_me: { en: "Remember me", hi: "मुझे याद रखें" },
  forgot_pin: { en: "Forgot PIN?", hi: "पिन भूल गए?" },
  contact_admin_reset: { en: "Please contact your administrator to reset your PIN.", hi: "अपना PIN रीसेट कराने के लिए कृपया अपने एडमिन से संपर्क करें।" },
  too_many_attempts: { en: "Too many failed attempts. Please try again after 15 minutes or contact your administrator.", hi: "बहुत अधिक असफल प्रयास हुए हैं। कृपया 15 मिनट बाद पुनः प्रयास करें या अपने एडमिन से संपर्क करें।" },
  reset_pin: { en: "Reset PIN", hi: "पिन रीसेट करें" },
  archive: { en: "Archive", hi: "आर्काइव" },
  restore: { en: "Restore", hi: "पुनर्स्थापित करें" },
  delete_permanently: { en: "Delete Permanently", hi: "स्थायी रूप से हटाएं" },
  archived_records: { en: "Archived Records", hi: "आर्काइव किए गए रिकॉर्ड" },
  audit_log: { en: "Audit Log", hi: "ऑडिट लॉग" },
  records: { en: "Records", hi: "रिकॉर्ड" },
  reason: { en: "Reason", hi: "कारण" },
  archive_reason_required: { en: "Please enter a reason for archiving.", hi: "आर्काइव करने का कारण दर्ज करें।" },
  delete_reason_required: { en: "Please enter a reason for deletion.", hi: "हटाने का कारण दर्ज करें।" },
  type_delete_confirm: { en: "Type DELETE to confirm permanent deletion", hi: "स्थायी विलोपन की पुष्टि हेतु DELETE टाइप करें" },
  permanent_delete_warning: { en: "This permanently removes the record from the database and CANNOT be undone.", hi: "यह रिकॉर्ड को डेटाबेस से स्थायी रूप से हटा देता है और इसे पूर्ववत नहीं किया जा सकता।" },
  cannot_delete_deps: { en: "Cannot delete: this record is referenced by other data. Use Archive instead.", hi: "हटाया नहीं जा सकता: यह रिकॉर्ड अन्य डेटा द्वारा संदर्भित है। इसके बजाय आर्काइव का उपयोग करें।" },
  archived_success: { en: "Archived successfully", hi: "सफलतापूर्वक आर्काइव किया गया" },
  restored_success: { en: "Restored successfully", hi: "सफलतापूर्वक पुनर्स्थापित किया गया" },
  deleted_success: { en: "Permanently deleted", hi: "स्थायी रूप से हटाया गया" },
  confirm_archive: { en: "Archive this record?", hi: "इस रिकॉर्ड को आर्काइव करें?" },
  dependencies_found: { en: "dependent record(s) found in", hi: "निर्भर रिकॉर्ड मिले:" },
  no_records: { en: "No records", hi: "कोई रिकॉर्ड नहीं" },
  new_pin: { en: "New 4-Digit PIN", hi: "नया 4-अंकीय पिन" },
  home: { en: "Home", hi: "होम" },
  visits: { en: "Visits", hi: "विज़िट" },
  followups: { en: "Follow-ups", hi: "फॉलो-अप" },
  summary: { en: "Summary", hi: "सारांश" },
  profile: { en: "Profile", hi: "प्रोफ़ाइल" },
  start_my_day: { en: "Start My Day", hi: "दिन शुरू करें" },
  add_visit: { en: "Add Visit", hi: "विज़िट जोड़ें" },
  todays_summary: { en: "Today's Summary", hi: "आज का सारांश" },
  pending_followups: { en: "Pending Follow-ups", hi: "लंबित फॉलो-अप" },
  end_my_day: { en: "End My Day", hi: "दिन समाप्त करें" },
  start_field_work: { en: "Start Field Work", hi: "फील्ड कार्य शुरू करें" },
  call_target: { en: "Call Target", hi: "कॉल लक्ष्य" },
  completed_calls: { en: "Completed Calls", hi: "पूर्ण कॉल" },
  order_value: { en: "Order Value", hi: "ऑर्डर मूल्य" },
  collection: { en: "Collection", hi: "संग्रह" },
  headquarters: { en: "Headquarters", hi: "मुख्यालय" },
  working_area: { en: "Working Area", hi: "कार्य क्षेत्र" },
  day_not_started: { en: "Day not started", hi: "दिन शुरू नहीं हुआ" },
  day_started: { en: "Day started", hi: "दिन शुरू हुआ" },
  report_submitted: { en: "Report submitted", hi: "रिपोर्ट जमा" },
  working_status: { en: "Working Status", hi: "कार्य स्थिति" },
  working_with: { en: "Working With", hi: "किसके साथ कार्य" },
  start_km: { en: "Starting KM (optional)", hi: "प्रारंभिक कि.मी. (वैकल्पिक)" },
  vehicle_type: { en: "Vehicle Type (optional)", hi: "वाहन प्रकार (वैकल्पिक)" },
  doctor_visit: { en: "Doctor Visit", hi: "डॉक्टर विज़िट" },
  retailer_visit: { en: "Retailer / Pharmacy Visit", hi: "मेडिकल स्टोर विज़िट" },
  stockist_visit: { en: "Stockist / Distributor Visit", hi: "स्टॉकिस्ट विज़िट" },
  select_doctor: { en: "Select Doctor", hi: "डॉक्टर चुनें" },
  select_retailer: { en: "Select Retailer", hi: "रिटेलर चुनें" },
  select_stockist: { en: "Select Stockist", hi: "स्टॉकिस्ट चुनें" },
  search: { en: "Search…", hi: "खोजें…" },
  recent: { en: "Recent", hi: "हाल के" },
  frequent: { en: "Frequent", hi: "अक्सर" },
  add_new: { en: "Add New", hi: "नया जोड़ें" },
  call_status: { en: "Call Status", hi: "कॉल स्थिति" },
  products_detailed: { en: "Products Detailed", hi: "प्रस्तुत उत्पाद" },
  select_all: { en: "Select All", hi: "सभी चुनें" },
  doctor_response: { en: "Doctor Response", hi: "डॉक्टर प्रतिक्रिया" },
  prescription_potential: { en: "Prescription Potential", hi: "प्रिस्क्रिप्शन संभावना" },
  samples: { en: "Samples / Materials", hi: "सैंपल / सामग्री" },
  follow_up: { en: "Follow-Up", hi: "फॉलो-अप" },
  remarks: { en: "Remarks (optional)", hi: "टिप्पणी (वैकल्पिक)" },
  save_visit: { en: "Save Visit", hi: "विज़िट सहेजें" },
  save_next: { en: "Save & Add Next", hi: "सहेजें और अगला जोड़ें" },
  cancel: { en: "Cancel", hi: "रद्द करें" },
  visit_purpose: { en: "Visit Purpose", hi: "विज़िट उद्देश्य" },
  product_availability: { en: "Product Availability", hi: "उत्पाद उपलब्धता" },
  order_received: { en: "Order Received?", hi: "ऑर्डर प्राप्त?" },
  retailer_response: { en: "Retailer Response", hi: "रिटेलर प्रतिक्रिया" },
  payment_collection: { en: "Payment / Collection", hi: "भुगतान / संग्रह" },
  stock_position: { en: "Product Stock Position", hi: "उत्पाद स्टॉक स्थिति" },
  order_booking: { en: "Order Booking", hi: "ऑर्डर बुकिंग" },
  collection_status: { en: "Collection Status", hi: "संग्रह स्थिति" },
  support_required: { en: "Support Required", hi: "आवश्यक सहायता" },
  amount: { en: "Amount", hi: "राशि" },
  payment_method: { en: "Payment Method", hi: "भुगतान विधि" },
  reference_no: { en: "Reference No.", hi: "संदर्भ संख्या" },
  net_order: { en: "Net Order Value", hi: "कुल ऑर्डर मूल्य" },
  gross: { en: "Gross", hi: "सकल" },
  discount: { en: "Discount", hi: "छूट" },
  tax: { en: "GST", hi: "जीएसटी" },
  qty: { en: "Qty", hi: "मात्रा" },
  rate: { en: "Rate", hi: "दर" },
  expenses: { en: "Expenses", hi: "व्यय" },
  add_expense: { en: "Add Expense", hi: "व्यय जोड़ें" },
  daily_total: { en: "Daily Total", hi: "दैनिक कुल" },
  needs_approval: { en: "Needs Approval", hi: "अनुमोदन आवश्यक" },
  market_feedback: { en: "Market Feedback", hi: "बाज़ार प्रतिक्रिया" },
  day_status: { en: "Day Status", hi: "दिन की स्थिति" },
  management_support: { en: "Management Support Required", hi: "प्रबंधन सहायता आवश्यक" },
  end_km: { en: "Ending KM (optional)", hi: "अंतिम कि.मी. (वैकल्पिक)" },
  submit_report: { en: "Submit Daily Report", hi: "दैनिक रिपोर्ट जमा करें" },
  report_preview: { en: "Report Preview", hi: "रिपोर्ट पूर्वावलोकन" },
  submit_success: { en: "Your daily report has been submitted successfully.", hi: "आपकी दैनिक रिपोर्ट सफलतापूर्वक जमा हो गई है।" },
  due_today: { en: "Due Today", hi: "आज देय" },
  upcoming: { en: "Upcoming", hi: "आगामी" },
  overdue: { en: "Overdue", hi: "अतिदेय" },
  completed: { en: "Completed", hi: "पूर्ण" },
  mark_complete: { en: "Mark Complete", hi: "पूर्ण करें" },
  reschedule: { en: "Reschedule", hi: "पुनर्निर्धारित" },
  call: { en: "Call", hi: "कॉल" },
  open_map: { en: "Map", hi: "मानचित्र" },
  dashboard: { en: "Dashboard", hi: "डैशबोर्ड" },
  manager_dashboard: { en: "Manager Dashboard", hi: "प्रबंधक डैशबोर्ड" },
  administration: { en: "Administration", hi: "प्रशासन" },
  export_csv: { en: "Export CSV", hi: "सीएसवी निर्यात" },
  products: { en: "Products", hi: "उत्पाद" },
  users: { en: "Users", hi: "उपयोगकर्ता" },
  areas: { en: "Areas", hi: "क्षेत्र" },
  approvals: { en: "Approvals", hi: "अनुमोदन" },
  target_vs_ach: { en: "Target vs Achievement", hi: "लक्ष्य बनाम उपलब्धि" },
  saved_offline: { en: "Saved Offline", hi: "ऑफ़लाइन सहेजा गया" },
  sync_pending: { en: "Sync Pending", hi: "सिंक लंबित" },
  synced_ok: { en: "Synchronized Successfully", hi: "सफलतापूर्वक सिंक" },
  online: { en: "Online", hi: "ऑनलाइन" },
  offline: { en: "Offline", hi: "ऑफ़लाइन" },
  save: { en: "Save", hi: "सहेजें" },
  edit: { en: "Edit", hi: "संपादित करें" },
  approve: { en: "Approve", hi: "अनुमोदन" },
  reject: { en: "Reject", hi: "अस्वीकार" },
  duplicate_warning: { en: "A similar record may already exist.", hi: "एक समान रिकॉर्ड पहले से मौजूद हो सकता है।" },
  use_existing: { en: "Use Existing Record", hi: "मौजूदा रिकॉर्ड उपयोग करें" },
  continue_creating: { en: "Continue Creating", hi: "बनाना जारी रखें" },
  name: { en: "Name", hi: "नाम" },
  mobile: { en: "Mobile", hi: "मोबाइल" },
  speciality: { en: "Speciality", hi: "विशेषज्ञता" },
  clinic: { en: "Clinic / Hospital", hi: "क्लिनिक / अस्पताल" },
  city: { en: "City", hi: "शहर" },
  last_visit: { en: "Last visit", hi: "अंतिम विज़िट" },
  no_data: { en: "No records yet", hi: "अभी कोई रिकॉर्ड नहीं" },
  working_hours: { en: "Working Hours", hi: "कार्य घंटे" },
  loading: { en: "Loading…", hi: "लोड हो रहा है…" },
  welcome: { en: "Welcome", hi: "स्वागत है" },
  not_started_yet: { en: "Please start your day to add visits.", hi: "विज़िट जोड़ने के लिए कृपया अपना दिन शुरू करें।" },
  team_overview: { en: "Team Overview", hi: "टीम अवलोकन" },
  started: { en: "Started", hi: "शुरू" },
  not_started: { en: "Not Started", hi: "शुरू नहीं" },
  pending_reports: { en: "Pending Reports", hi: "लंबित रिपोर्ट" },
  notifications: { en: "Notifications", hi: "सूचनाएँ" },
  no_notifications: { en: "No notifications", hi: "कोई सूचना नहीं" },
  notif_start_day: { en: "Start your day to begin reporting", hi: "रिपोर्टिंग शुरू करने के लिए अपना दिन शुरू करें" },
  notif_pending_report: { en: "Your daily report is pending", hi: "आपकी दैनिक रिपोर्ट लंबित है" },
  notif_followup_due: { en: "follow-up(s) due today", hi: "फॉलो-अप आज देय" },
  notif_followup_overdue: { en: "follow-up(s) overdue", hi: "फॉलो-अप अतिदेय" },
  notif_approvals: { en: "approval request(s) pending", hi: "अनुमोदन अनुरोध लंबित" },
  notif_not_started: { en: "rep(s) have not started the day", hi: "प्रतिनिधि ने दिन शुरू नहीं किया" },
  notif_pending_reports_n: { en: "report(s) pending submission", hi: "रिपोर्ट जमा होना बाकी" },
  share_order_pdf: { en: "Share Order PDF", hi: "ऑर्डर PDF शेयर करें" },
  share_day_report: { en: "Share Day Report PDF", hi: "दिन रिपोर्ट PDF शेयर करें" },
  visit_time: { en: "Visit Time", hi: "विज़िट का समय" },
  vt_now: { en: "Now", hi: "अभी" },
  vt_15: { en: "15 min ago", hi: "15 मिनट पहले" },
  vt_30: { en: "30 min ago", hi: "30 मिनट पहले" },
  vt_1h: { en: "1 hour ago", hi: "1 घंटा पहले" },
  vt_select: { en: "Select Time", hi: "समय चुनें" },
  selected_visit_time: { en: "Selected Visit Time", hi: "चयनित विज़िट समय" },
  warn_future: { en: "Visit time cannot be in the future.", hi: "विज़िट समय भविष्य में नहीं हो सकता।" },
  warn_before_start: { en: "Visit time is before your day start.", hi: "विज़िट समय आपके दिन प्रारंभ से पहले है।" },
  warn_conflict: { en: "This visit time may conflict with another visit. Please check before saving.", hi: "यह विज़िट समय किसी अन्य विज़िट से टकरा सकता है। सहेजने से पहले जांचें।" },
  warn_duplicate: { en: "You may have already recorded a visit to this contact today.", hi: "आपने आज इस संपर्क की विज़िट पहले ही दर्ज कर ली होगी।" },
  warn_backdate: { en: "Visit time is older than allowed. Please check.", hi: "विज़िट समय अनुमत सीमा से पुराना है। कृपया जांचें।" },
  please_check: { en: "Please check before saving", hi: "सहेजने से पहले कृपया जांचें" },
  check_and_change: { en: "Check and Change", hi: "जांचें और बदलें" },
  save_anyway: { en: "Save Anyway", hi: "फिर भी सहेजें" },
  correction_reason: { en: "Correction Reason", hi: "सुधार कारण" },
  cr_incorrect: { en: "Incorrect time selected", hi: "गलत समय चुना गया" },
  cr_later: { en: "Visit reported later", hi: "विज़िट बाद में दर्ज" },
  cr_network: { en: "Phone or network problem", hi: "फ़ोन या नेटवर्क समस्या" },
  cr_forgot: { en: "Forgot to report immediately", hi: "तुरंत दर्ज करना भूल गए" },
  cr_other: { en: "Other", hi: "अन्य" },
  todays_visits: { en: "Today's Visits", hi: "आज की विज़िट" },
  edit_time: { en: "Edit Time", hi: "समय संपादित करें" },
  recent_visits: { en: "Recent Visits", hi: "हाल की विज़िट" },
  max_backdate: { en: "Max visit-time backdate (minutes)", hi: "अधिकतम विज़िट-समय बैकडेट (मिनट)" },
  save_time: { en: "Save Time", hi: "समय सहेजें" },
  settings: { en: "Settings", hi: "सेटिंग्स" },
  contacts: { en: "Contacts", hi: "संपर्क" },
  employees: { en: "Employees", hi: "कर्मचारी" },
  hq_areas: { en: "HQ & Areas", hi: "मुख्यालय व क्षेत्र" },
  targets: { en: "Targets", hi: "लक्ष्य" },
  activate: { en: "Activate", hi: "सक्रिय करें" },
  deactivate: { en: "Deactivate", hi: "निष्क्रिय करें" },
  confirm_deactivate: { en: "Deactivate this record?", hi: "इस रिकॉर्ड को निष्क्रिय करें?" },
  add_product: { en: "Add New Product", hi: "नया उत्पाद जोड़ें" },
  product_code: { en: "Product Code", hi: "उत्पाद कोड" },
  reset_pin_btn: { en: "Reset PIN", hi: "पिन रीसेट" },
  daily_targets: { en: "Daily Targets", hi: "दैनिक लक्ष्य" },
  monthly_targets: { en: "Monthly Targets", hi: "मासिक लक्ष्य" },
  t_doctors: { en: "Doctors", hi: "डॉक्टर" },
  t_retailers: { en: "Retailers", hi: "रिटेलर" },
  t_stockists: { en: "Stockists", hi: "स्टॉकिस्ट" },
  t_order: { en: "Order", hi: "ऑर्डर" },
  t_collection: { en: "Collection", hi: "संग्रह" },
};

export function t(key, lang) {
  const e = DICT[key];
  if (!e) return key;
  return e[lang] || e.en;
}

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("apto_lang") || "en");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("apto_lang", l);
    if (localStorage.getItem("apto_token")) api.post("/auth/language", { language: l }).catch(() => {});
  }, []);
  const tt = useCallback((k) => t(k, lang), [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: tt }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
